import getNative from './_getNative.js';
import root from './_root.js';

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

export default DataView;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_DataView.js
// module id = 632
// module chunks = 0